import ActiveMobileTab from './ActiveMobileTab';

export default ActiveMobileTab;
